import React from 'react';
import { Link } from 'react-router-dom';

import './header.scss';

export function HeaderComponent() {
  return (
    <div className="page-top">
      <Link to="/" className="page-title">
        <h1>Monty</h1>
        <h2>La veille d'UX-Republic</h2>
      </Link>

      <nav>
        <button className="link-button reversed">
          <Link to="/admin">Accès Admin</Link>
        </button>
        <button className="link-button">
          <Link to="/propose">Proposer un article</Link>
        </button>
      </nav>
    </div>
  );
}
